import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import logger from 'redux-logger';
import IdleTimer from 'react-idle-timer';
import ManageConsumers from './components/manageConsumerComponent/ManageConsumers';
import { store } from "../src/redux/store"
import deviceDetails from "../src/components/loginComponent/deviceDetails";
import '../src/assests/css/bootstrap.min.css';
import '../src/assests/css/master.css';
import '../src/assests/css/calendar.css';

// import ViewCampaign from './components/campaigns/viewCampaign';
// import { IdleTimeOutModal } from './components/login/IdleTimeOutModal';


import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import ActivityLog from './components/activityLogComponet/ActivityLog';
import BillPayment from './components/billPaymentComponent/BillPayment';
import BillList from './components/billListComponent/BillList';
import BatchList from './components/billListComponent/BatchList';
import BatchConsumer from "./components/billListComponent/BatchConsumer";
import AllConsumers from './components/allConsumerComponent/AllConsumers';
import UploadHistory from './components/uploadHistoryComponent/UploadHistory';
import ProfileDetails from './components/profileComponent/ProfileDetails';
import ManagePayment from './components/paymentComponet/ManagePayment';
import PaymentSuccess from './components/paymentComponet/PaymentSuccess';
import Login from './components/loginComponent/Login';
import Dashboard from './components/dashBoardComponent/Dashboard';
import AccountLedger from './components/accountLedgerComponent/AccountLedger';
import Payment from './components/paymentComponet/Payment';
import PaymentDetails from './components/paymentComponet/PaymentDetails';
import AddNewConsumer from './components/allConsumerComponent/AddNewConsumer';
import AddedConsumerrDetails from "./components/allConsumerComponent/AddedConsumerrDetails";
import { setDeviceInfo } from "./redux/misc-data/misc-data.action";
import ErrorPage from "./components/loginComponent/ErrorPage";
import WhiteLabelLogin from "./components/loginComponent/WhiteLabelLogin";



class App extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      currentUser: null,
      timeout: 1000 * 1 * 1 * 10 * 60,
      // timeout:1000 *1*1*5,
      showModal: false,
      userLoggedIn: false,
      isTimedOut: false,
      authorizedRoutes: [{
        path: '/dashboard/analysis/realtime',
        exact: true,
        permissions: ['admin', 'user'],
        redirect: '/login',
        component: Dashboard,
      }, {
        path: '/dashboard/analysis/offline',
        exact: true,
        permissions: ['admin', 'user'],
        redirect: '/login',
        component: Dashboard,
      }, {
        path: '/dashboard/workplace',
        exact: true,
        permissions: ['admin', 'user'],
        redirect: '/login',
        component: Dashboard,
      }, {
        path: '/exception/403',
        exact: true,
        permissions: ['god'],
        component: Login,
        unauthorized: Login,
      }],

      normalRoutes: [{
        path: '/',
        exact: true,
        redirect: '/dashboard/analysis/realtime',
      }, {
        path: '/login',
        exact: true,
        component: Login,
      }]


    };

    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }


  _onAction(e) {
    console.log('user did something', e)
    this.setState({ isTimedOut: false })
  }

  _onActive(e) {
    console.log('user is active', e)
    this.setState({ isTimedOut: false })
  }

  _onIdle(e) {
    console.log('user is idle', e);
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      console.log('isTimedOut::::::::' + isTimedOut);

    } else {
      this.setState({ showModal: true })
      this.idleTimer.reset();
      //this.setState({isTimedOut: true})
    }

  }

  handleClose() {
    this.setState({ showModal: false })
  }

  handleLogout() {
    this.setState({ showModal: false })
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    if (this.props.deviceInfo == '' ||
      this.props.deviceInfo == undefined ||
      this.props.deviceInfo == null) {
      this.getDeviceInfo();
    } else {
      console.log('already device info found...' + JSON.stringify(this.props.deviceInfo))
    }

  }
  getDeviceInfo = () => {
    navigator.geolocation.getCurrentPosition(function (position) {

      console.log("Latitude is :", position.coords.latitude);

      console.log("Longitude is :", position.coords.longitude);

      const deviceInfo = deviceDetails.fetchDeviceInfo(position.coords.latitude,
        position.coords.longitude);
      deviceInfo.then((deviceResponse) => {
        store.dispatch(setDeviceInfo(deviceResponse));
      })
    })
  }



  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }



  render() {

    const middlewares = [];

    if (process.env.NODE_ENV === 'development') {
      middlewares.push(logger);
    }



    // var userProfileResponseStatus=this.props.userProfileResponse==''?'blank':this.props.userProfileResponse==null?'null':'above value';
    // console.log('userProfileResponseStatus..',userProfileResponseStatus);
    return (

      <div>
        <Routes>
          <Route path="something" element={<div>This is not important</div>} />
          <Route path='manage-consumer' element={<ManageConsumers />}></Route>
          <Route path='activity-log' element={<ActivityLog />}></Route>
          <Route path='bill-history' element={<BillPayment />}></Route>
          <Route path='bill-list' element={<BillList />}></Route>
          <Route path='batch-list' element={< BatchList/>}></Route>
          <Route path='batch-consumer' element={< BatchConsumer/>}></Route>
          <Route path='account-ledger' element={<AccountLedger />}></Route>
          <Route path='/403' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          <Route path='all-consumer' element={<AllConsumers />}></Route>
          <Route path='added-consumer-details' element={<AddedConsumerrDetails />}></Route>
          <Route path='upload-history' element={<UploadHistory />}></Route>
          <Route path='profile' element={<ProfileDetails />}></Route>
          <Route path='manage-payment' element={<ManagePayment />}></Route>
          <Route path='payment-success' element={<PaymentSuccess />}></Route>
          <Route path='payment' element={<Payment />}></Route>
          <Route path='payment-details' element={<PaymentDetails />}></Route>
          <Route path='dashboard' element={<Dashboard />}></Route>
          <Route path='add-new-consumer' element={<AddNewConsumer />}></Route>
          <Route path='/' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/whitelabel/login' element={<WhiteLabelLogin />}></Route>
          <Route path='*' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          {/* <Route path="*" element={
            <div>
              <h1>Page don't exist</h1>
              <Routes>
                <Route path="*" element={<div></div>} />
              </Routes>
            </div>
          } /> */}
        </Routes>
      </div>



    )



  }
}


const mapStateToProps = ({
  // showAddHide: { viewSection, viewDashBoardSection },
  errorMessageReduce: { errorMessage },
  miscReduce: { phone, deviceInfo, token, activeStatus, logOutWarningStatus, agentInfo,
    loginTime, uniqueToken, currentlyAddedMemberId, curWindow },


  authReduce: { isAccess }
}) => ({
  // viewSection, viewDashBoardSection, 
  errorMessage,
  phone, deviceInfo, token, activeStatus, logOutWarningStatus, agentInfo,
  loginTime, uniqueToken, currentlyAddedMemberId, curWindow,
  isAccess
});


export default connect(mapStateToProps, null)(App);